import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=d5a6371a&lang=pug&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5a6371a')) {
      api.createRecord('d5a6371a', component.options)
    } else {
      api.reload('d5a6371a', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=d5a6371a&lang=pug&", function () {
      api.rerender('d5a6371a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/modal/Modal.vue"
export default component.exports